import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import buildConfig from 'appRoot/build.config.json';

const versionName = ApplicationFeatures.getAllFeatures().versionName;

/**
 * Provides entry point used to access xcenter (depends on the environment and versionName for the app)
 * @param {Boolean} IS_DISTRIBUTION_BUILD - flag to separate /app (Dev) and distribution builds
 * @returns {String}
 */
export default (IS_DISTRIBUTION_BUILD) => {
    let applicationPath = ''; // development environment redirect direct to xcenter without app name

    if (IS_DISTRIBUTION_BUILD) { // dist environment
        if (buildConfig.releaseName) { // one releaseName
            applicationPath = `/${buildConfig.releaseName}`;
        } else { // version dependent releaseName
            const versionData = buildConfig.versions.filter((version) => {
                return version.features.versionName === versionName;
            })[0];
            applicationPath = `/${versionData.releaseName}`;
        }
    }

    return applicationPath;
};